<template>
  <b-container class="profile-container p-0">
      <b-row class="d-flex justify-content-start">
        <b-col md="5" lg="4" xl="3" class="p-3 px-4" >
          <b-nav pills vertical class="px-2 d-none d-md-block d-lg-block d-xl-block">
            <b-nav-item
                v-for="(item, index) of menuItems"
                :key="index"
                :active="activeMenu === item.activeName"
                @click="activeMenu = item.activeName"
            >
              {{ item.description | localize}}
            </b-nav-item>
          </b-nav>
          <b-form-select v-model="activeMenu" class="d-xs-block d-sm-block d-md-none d-lg-none d-xl-none">
            <b-form-select-option
                v-for="(item, index) of menuItems"
                :key="index"
                :value="item.activeName"
            >
              {{ item.description | localize}}
            </b-form-select-option>
          </b-form-select>
        </b-col>
        <b-col md="7" lg="8" xl="9">
          <component :is="activeMenu"></component>
        </b-col>
      </b-row>
  </b-container>
</template>
<script>
import ChangePassword from './forms/ChangePassword'
import ChangeMail from './forms/ChangeMail'
import ChangeTel from './forms/ChangeTel'
import ChangeFio from './forms/ChangeFio'
import DeleteLS from './forms/DeleteLS'
import DeleteProfile from './forms/DeleteProfile'
import ProfileSubscriptions from './forms/ProfileSubscriptions'

export default {
  name: 'UserProfile',
  components: {
    'change-mail': ChangeMail,
    'change-password': ChangePassword,
    'change-telephone': ChangeTel,
    'change-fio': ChangeFio,
    'delete-profile': DeleteProfile,
    'delete-ls': DeleteLS,
    'profile-subscriptions': ProfileSubscriptions
  },
  data: ()=> ({
    activeMenu: null,
    menuItems: [
      { description: 'userProfileChengeEmailHeader', activeName: 'change-mail' },
      { description: 'userProfileChangeTel', activeName: 'change-telephone' },
      { description: 'userProfileChangeFIO', activeName: 'change-fio' },
      { description: 'userProfileChengePassHeader', activeName: 'change-password' },
      { description: 'userProfileSubscriptions', activeName: 'profile-subscriptions' },
      { description: 'userProfileDeleteLS', activeName: 'delete-ls' },
      { description: 'userProfileDeleteHeader', activeName: 'delete-profile' },
    ]
  }),
  async mounted(){
    this.activeMenu = this.menuItems[0].activeName
    localStorage.setItem('weltumLastUrl', window.location.pathname)
  },
}
</script>
<style>
  .nav-pills{
    border-right: 1px solid #ddd;
  }
  .nav-pills .nav-link{
    margin: 10px 0px;
    padding: 8px 0px;
    font-size: 1rem;
    color: #333!important;
    position: relative!important;
    text-transform: uppercase;
    line-height: 1;
    text-align: left;
    max-width: 250px;
  }
  .nav-pills .nav-link.active{
    background-color: transparent!important
  }
    .nav-pills .nav-link::before{
    content: '';
    position: absolute;
    bottom: 1px;
    left: 0;
    right: 0;
    width: 0%;
    height: 1px;
    background: #dc1522;
    transition: 0.2s ease-in!important;
  }

  .nav-pills .nav-link.active::before{
    width: 100%;

  }
  .nav-pills .nav-link:hover::before{
    width: 100%;
  }
  .card{
    width: 100%;
    min-height: 500px;

  }
  .tabs{
    min-height: 500px;
  }
  .card-body{
    padding: 0px!important;
    height: 100%;
  }

</style>
